export const facebook_style = {
    background: "#3B5998",
    height: "50px",
    width: "50px",
    padding: "12px",
    color: "white",
    borderRadius: "10px",
};

export const twitter_style = {
    background: "#55ACEE",
    padding: "12px",
    width: "50px",
    height: "50px",
    color: "white",
    borderRadius: "10px",
};

export const instagram_style = {
    background: "radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%,#d6249f 60%,#285AEB 90%)",
    padding: "10px",
    color: "white",
    width: "50px",
    height: "50px",
    borderRadius: "10px",
};